export enum TipoRecapitoDigitaleEnum {
  PEC = <any>"PEC",
  APACI = <any>"APACI",
}
